export default {
  title: 'Ultimele 4 săptămâni',
  item_interval: '(1)[1 vizită];(2)[2 vizite];(3-5)[3-5 vizite];(6-inf)[6+ vizite];',
  total: 'Total vizitatori',
};
